// src/components/common/ConfirmationModal.js
import React from 'react';
import './ConfirmationModal.css';

/**
 * Componente Modal de Confirmación
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.isOpen - Indica si el modal está abierto
 * @param {Function} props.onClose - Función para cerrar el modal
 * @param {Function} props.onConfirm - Función para confirmar la acción
 * @param {string} props.message - Mensaje a mostrar
 * @param {string} props.confirmText - Texto del botón de confirmación
 * @param {string} props.cancelText - Texto del botón de cancelación
 */
const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar'
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="confirmation-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Confirmar Acción</h3>
          <button className="close-btn" onClick={onClose} aria-label="Cerrar">×</button>
        </div>

        <div className="modal-body">
          <p>{message}</p>
        </div>

        <div className="modal-footer">
          <button
            className="btn-confirm"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
          <button
            className="btn-cancel"
            onClick={onClose}
          >
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;